import { render } from "./HeaderrView.vue?vue&type=template&id=359d7116"
import script from "./HeaderrView.vue?vue&type=script&lang=js"
export * from "./HeaderrView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__